import React, {useEffect, useState} from "react";
import Form from "../../../../../components/common/form/Form";
import {DataTableColumn} from "../../../../../components/common/datatable/DataTableTypes";
import Modal from "../../../../../components/common/form/Modal";
import {DataTable} from "../../../../../components/common/datatable/DataTable";
import {useSearchSubDivisionQueryTrimmed} from "../../../../data/subDivision/subDivisionApi";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import {FaMagnifyingGlass} from "react-icons/fa6";
import {SearchInputWrapper} from "../../../../../components/common/datatable/filter/SearchInputWrapper";

interface SubdivisionListModalProps {
    show?: any;
    setShow?: any;
    certificate?: any;
    showAccount?: any;
    checkBox?: any;
    setCheckBox?: any;
    setDisable?: any;
    countyName?: any;
    county?: any;
    isHoaTable?: any;
    addParentAccountsForSubdivision?: any;
    setUpdatedAccountIndexList?: any;
    getSubdivisionByNameAndCountyApi?: any;
    setSubdivisionId?: any
}

const SubdivisionListModal: React.FC<SubdivisionListModalProps> = ({
                                                                       show,
                                                                       setShow,
                                                                       certificate,
                                                                       showAccount,
                                                                       checkBox,
                                                                       setCheckBox,
                                                                       setDisable,
                                                                       countyName,
                                                                       county,
                                                                       isHoaTable = true,
                                                                       addParentAccountsForSubdivision,
                                                                       setUpdatedAccountIndexList,
                                                                       getSubdivisionByNameAndCountyApi,
                                                                       setSubdivisionId
                                                                   }) => {


    const [obj, setObj] = useState<Record<string, any>>({});
    const [id, setId] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!show) {
            setIsLoading(false)
        }
    }, [show]);


    function handleSubdivisionSubmit(e: any) {
        e.preventDefault();
        setIsLoading(true);
        if (!obj?.id) return;

        setUpdatedAccountIndexList((prev: any) =>
            prev.includes(showAccount) ? prev : [...prev, showAccount]
        );

        const id = obj.id;
        let name = obj.subdivisionKey.name;
        if (setSubdivisionId) {
            setSubdivisionId(obj.id)
        }

        setDisable(true);

        const account = certificate.accounts?.[showAccount];
        if (!account) {
            console.warn("Invalid account index");
            setDisable(false);
            return;
        }

        if (!isHoaTable) {
            addParentAccountsForSubdivision(id, setDisable, setShow);
        } else {
            getSubdivisionByNameAndCountyApi({
                name: name,
                countyId: account.countyId,
                targetCerts: ["BOTH", "HOA"],
                id: id,
                accountNumber: account.accountNumber,
            })
                .unwrap()
                .then((data: any) => {
                    setDisable(false);
                    setShow(false);
                })
                .catch((error: any) => {
                    console.error("Subdivision fetch error:", error);
                    setDisable(false);
                    setShow(false);
                });
        }
    }


    const selectSubdivision = (props: any) => (
        <span className={'active cursor'} id={props.row.original.id + "1"}>{props.value}</span>
    );

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "subdivisionKey.name",
            cell: selectSubdivision,
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter name..."}
                                                     name={"name"} accessor={"name"} />,
                overrideFilterAccessor: "name"

            }]

        },
        {
            label: "Subdivision Code", accessor: "subdivisionCode",
            cell: selectSubdivision,
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Code..."}
                                                     name={"subdivisionCode"} accessor={"subdivisionCode"} />,
            }]
        },
        {
            label: "Phase", accessor: "subdivisionKey.phase",
            cell: (props: any) => {
                return selectSubdivision(props);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter phase..."}
                                                     name={"phase"} accessor={"phase"} />,
                overrideFilterAccessor: "phase"
            }]
        },


        {
            label: "Unit", accessor: "subdivisionKey.unit",
            cell: (props: any) => {
                return selectSubdivision(props);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter unit..."}
                                                     name={"unit"} accessor={"unit"} />,
                overrideFilterAccessor: "unit"
            }]

        },


        {
            label: "Section", accessor: "subdivisionKey.section",
            cell: (props: any) => {
                return selectSubdivision(props);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter section..."}
                                                     name={"section"} accessor={"section"} />,
                overrideFilterAccessor: "section"
            }]
        },
        {
            label: "City", accessor: "city",
            cell: (props: any) => {
                return selectSubdivision(props);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter city..."}
                                                     name={"city"} accessor={"city"} />,
            }]
        },

        {
            label: "State", accessor: "county.state.stateName",
            cell: (props: any) => {
                return selectSubdivision(props);
            }
        },


        {
            label: "County", accessor: "county.countyName",
            cell: (props: any) => {
                return selectSubdivision(props);
            }
        },
    ];


    let modalTitle = "Subdivision Selector - " + countyName

    let hasCreateFormBtn = {
        path: "/subdivisions/create?county=" + county,
        label: "Add Subdivision"
    }

    return (
        <Modal
            title={modalTitle}
            show={show}
            setShow={setShow}
            hoa={isHoaTable}
            className="w-2/4 bg-text-0 rounded-lg shadow-lg"
            fields={
                <>
                    <Form onSubmit={handleSubdivisionSubmit} fields={
                        <>
                            <div className="modal-body  overflow-auto [-ms-overflow-style:none] [scrollbar-width:none]">
                                <div className={isHoaTable ? "table_data hoa_table" : "table_data"}>

                                    <DataTable
                                        isHoa={isHoaTable}
                                        classname={isHoaTable ? "bg-highlight-1 text-[white] border-highlight-1" : "bg-highlight-5 text-[white] mt-3"}
                                        columns={columns}
                                        actions={{
                                            fetchAction: useSearchSubDivisionQueryTrimmed,
                                        }}
                                        defaultSortOptions={{
                                            accessor: "creationDate",
                                            direction: "desc"
                                        }}
                                        defaultFilter={{
                                            pageNumber: 0,
                                            pageSize: 5,
                                            county: county
                                        }}
                                        renderOptions={{
                                            skipUserSettingRender: true,
                                            skipFilterButtonRender: true
                                        }}

                                        appendFilterToUrl={false}
                                        rowSelectionOptions={{
                                            enableRowSelection: true,
                                            onSelectionChange: (selectedRows: Set<any>) => {
                                                const [row] = Array.from(selectedRows);
                                                if (row) {
                                                    setId(row.id);
                                                    setObj(row);
                                                }
                                            },
                                        }}
                                        formCheckForModals={true}
                                        defaultFilterFormExpanded={true}
                                        hasCreateFormBtn={hasCreateFormBtn}
                                    />


                                </div>
                            </div>

                            {isHoaTable && certificate.accounts[showAccount]?.propertySubdivision && certificate.accounts[showAccount].propertySubdivision !== '-' && (
                                <div className="mt-2">
                                    <input type="checkbox" id="checkbox_id" className="modal_label"
                                           onChange={() => setCheckBox(!checkBox)}/>
                                    <label className="ml-2">
                                        Add <b>{certificate.accounts[showAccount].propertySubdivision}</b> as alias ?
                                    </label>
                                </div>
                            )}

                            {/* Modal Footer */}
                            <div className="modal-footer border-t border-gray-300 px-4 py-2 flex justify-end gap-1">
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "cancel",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Submit",
                                                type: "submit",
                                                isHoa: isHoaTable,
                                                isLoading: isLoading,
                                                isDisabled: !obj?.id || isLoading
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align={"end"}
                                    gap={2}
                                />
                            </div>


                        </>
                    }/>
                </>
            }
        />
    );
};

export default SubdivisionListModal;
